import { MenuItem, Typography } from '@mui/material';
import { IOSSwitch } from '../../../../components/atoms/iosSwitch';
export default function ToolbarToggleMenu(_ref) {
    var menu = _ref.menu, visibleActions = _ref.visibleActions, onClick = _ref.onClick;
    return menu.map(function (item) {
        var _item$startIcon;
        if (item.hidden || (visibleActions === null || visibleActions === void 0 ? void 0 : visibleActions[item.name]) === false)
            return null;
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: item.name,
            key: item.name,
            onClick: onClick,
            sx: {
                columnGap: 2,
                color: 'primary'
            }
        }, item.type !== 'IconButton' ? (_item$startIcon = item.startIcon) !== null && _item$startIcon !== void 0 ? _item$startIcon : item.label[0] : item.children, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            flexGrow: 1
        }, item.label), /*#__PURE__*/ React.createElement(IOSSwitch, {
            checked: Boolean(item.checked)
        }));
    });
}
